<template>
  <div ref="videoContainer" style="width: 100%; height: 100%;">
    <video
        ref="videoPlayer"
        autoplay
        playsinline
        class="w-full h-full"
        :poster="posterUrl"
    ></video>
  </div>
</template>

<script>
export default {
  name: 'pa-shaka',

  props: {
    manifestUrl: {
      type: String,
      required: true
    },
    posterUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      player: null,
      video: null
    };
  },

  mounted() {
    const shaka = require('shaka-player/dist/shaka-player.ui.js');

    const video = this.$refs.videoPlayer;
    const player = new shaka.Player(video);

    this.video = video;
    this.player = player;

    new shaka.ui.Overlay(
        player,
        this.$refs.videoContainer,
        video
    );

    /* ========= SHAKA EVENTS ========= */
    player.addEventListener('buffering', this.onBuffering);
    player.addEventListener('playing', this.onPlaying);
    player.addEventListener('error', this.onError);

    /* ========= VIDEO EVENTS ========= */
    video.addEventListener('play', this.onPlaying);
    video.addEventListener('pause', this.onPaused);
    video.addEventListener('ended', this.onEnded);

    player.load(this.manifestUrl)
        .then(() => {
          this.$emit('ready');
        })
        .catch(this.onError);
  },

  beforeUnmount() {
    this.player?.destroy();
  },

  methods: {
    onBuffering(e) {
      if (e.buffering) {
        this.$emit('buffering');
      }
    },

    onPlaying() {
      this.$emit('playing');
    },

    onPaused() {
      if (!this.video.ended) {
        this.$emit('paused');
      }
    },

    onEnded() {
      this.$emit('ended');
    },

    onError(error) {
      this.$emit('error', error);
    }
  }
};
</script>

<style>
@import '../../node_modules/shaka-player/dist/controls.css';

.size {
  width: 800px;
}
</style>
